"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DynamicSchemaDefinition_1 = require("./DynamicSchemaDefinition");
const DynamicSchemaValue_1 = require("./DynamicSchemaValue");
class ProjectDiff {
    constructor({ creativeBrief, assetCategory, }) {
        this.toJSON = () => ({
            creativeBrief: this.creativeBrief && this.creativeBrief.toJSON(),
            assetCategory: this.assetCategory && this.assetCategory.toJSON(),
        });
        this.creativeBrief = creativeBrief;
        this.assetCategory = assetCategory;
    }
}
ProjectDiff.fromJSON = (json, creativeBriefDefinition, assetCategoryDefinition) => {
    const { creativeBrief, assetCategory } = Object.assign({}, json);
    const _creativeBriefDefinition = creativeBriefDefinition
        ? DynamicSchemaDefinition_1.default.fromJSON(creativeBriefDefinition)
        : undefined;
    const _creativeBrief = creativeBrief && _creativeBriefDefinition
        ? DynamicSchemaValue_1.default.fromJSONAndDefinition(creativeBrief, _creativeBriefDefinition)
        : undefined;
    const _assetCategoryDefinition = assetCategoryDefinition
        ? DynamicSchemaDefinition_1.default.fromJSON(assetCategoryDefinition)
        : undefined;
    const _assetCategory = assetCategory && _assetCategoryDefinition
        ? DynamicSchemaValue_1.default.fromJSONAndDefinition(assetCategory, _assetCategoryDefinition)
        : undefined;
    return new ProjectDiff({
        creativeBrief: _creativeBrief,
        assetCategory: _assetCategory,
    });
};
exports.default = ProjectDiff;
